import { type FC } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { Body2, Radio } from '@sbol/nova';
import type { AnswersViewProps } from '../AnswersView';
import type { SingleSelectModel } from './SingleSelectModel';
import styles from './SingleSelect.module.scss';

export const SingleSelect: FC<AnswersViewProps<SingleSelectModel>> = observer(({ questionModel }) => {
  const { question, handleClickOption, disabled } = questionModel;

  return (
    <ul className={styles.SingleSelect}>
      {question.form_answers.map((answer) => (
        <li
          key={answer.id}
          className={clsx(styles.Option, disabled && styles.disabled)}
          onClick={!disabled ? () => handleClickOption(answer.id) : undefined}
        >
          <Radio
            name="SingleSelect"
            value={answer.id}
            checked={questionModel.isAnswerSelected(answer)}
            onChange={() => {}} // Чтобы реакт не ругался
            disabled={disabled}
          />
          <Body2 className={styles.Option_text}>{answer.answer_text}</Body2>
        </li>
      ))}
    </ul>
  );
});
